export default {
  getToken() {
    const token = sessionStorage.getItem('csrf_token');

    if (!token || token.length === 0) throw new Error('NO_CSRF_TOKEN');

    return token;
  },
  setToken(token) {
    return sessionStorage.setItem('csrf_token', token);
  },
};
